import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const HCSA_LOADING = 'HCSA_LOADING'
export const HCSA_SUCCESS = 'HCSA_SUCCESS'
export const HCSA_FAILED = 'HCSA_FAILED'

export const fetchHCSA = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/healthCareSpendingAccount`,
        prefix: 'HCSA'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/hcsaActions.js